// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 678 ? "47bf8baf" : chunkId) + "." + {"393":"e4e875e4c0ae0756","678":"667c37db725d856f","698":"731661b60cfcd628","801":"9ee3d9d0a0f42e1b","825":"619b801276ad55f7"}[chunkId] + ".js";
};